export var CampaignEarlyAccessState;
(function (CampaignEarlyAccessState) {
    CampaignEarlyAccessState["Active"] = "ACTIVE";
    CampaignEarlyAccessState["Expired"] = "EXPIRED";
})(CampaignEarlyAccessState || (CampaignEarlyAccessState = {}));
